import { _ as _sfc_main } from "./VaInnerLoading.vue_vue_type_script_lang-8988d41b.mjs";
import { resolveComponent, openBlock, createElementBlock, mergeProps, renderSlot, createVNode, createCommentVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaInnerLoading_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = {
  key: 0,
  class: "va-inner-loading__overlay",
  "aria-hidden": "true"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  return openBlock(), createElementBlock("div", mergeProps({
    class: ["va-inner-loading", _ctx.computedClass],
    "aria-live": "polite"
  }, _ctx.ariaAttributesComputed), [
    renderSlot(_ctx.$slots, "default"),
    _ctx.$props.loading ? (openBlock(), createElementBlock("div", _hoisted_1, [
      createVNode(_component_va_icon, {
        class: "va-inner-loading__spinner",
        spin: "",
        color: _ctx.colorComputed,
        size: _ctx.$props.size,
        name: _ctx.$props.icon
      }, null, 8, ["color", "size", "name"])
    ])) : createCommentVNode("", true)
  ], 16);
}
const _VaInnerLoading = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaInnerLoading as _
};

import '../../../VaInnerLoading.css';
//# sourceMappingURL=VaInnerLoading-1d2fcbd1.mjs.map
